var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-right"},on:{"after-leave":_vm.afterLeave}},[_c('keep-alive',[_c('router-view',{staticClass:"fui-content",attrs:{"id":"fuiContent"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }